<template lang="pug">
	
	v-touch(v-on:tap="action").burger-button
		span(v-for="n in 3").bar
		span.text Menu

</template>

<script>
		
	import Vue from 'vue'
	import Component from 'vue-class-component'
	import $ from 'jquery'
	import { TweenMax } from 'gsap'
	import Scroller from '../utils/scroller.js'
	import Ticker from '../utils/ticker.js'
	import Section from '../abstracts/section'
	
  @Component({
		name: 'BurgerButton',
		components: {  },
		props: ["action"]
	})

	class BurgerButton extends Vue {

		mounted () {}
				
		init () {}

		_resize () {}	

	}

	export default BurgerButton

</script>


<style lang="stylus">
	
	@import '../theme/utils'
	@import '../theme/variables'
	
	.burger-button
		
		width 20px
		height 16px
		display flex
		flex-direction column
		justify-content space-between
		align-items center
		cursor pointer
		
		span.bar
			width 20px
			height 2px
			display block
			background-color #fff
			transition all .3s

			&:nth-child(2)
				width 16px

		.text
			color #fff
			position absolute
			text-transform uppercase
			font-weight 300
			font-family $FONT_SECONDARY
			font-size 12px
			letter-spacing 0.15em
			top 2px
			opacity 0
			transition opacity .3s


		&:hover
			.bar
				&:nth-child(1)
					transform translateY(-4px)
				
				&:nth-child(2)
					opacity 0

				&:nth-child(3)
					transform translateY(4px)

			.text
				opacity 1



</style>


// WEBPACK FOOTER //
// burger-button.vue?546ad0ea